import * as React from 'react';

import { Link } from '@coursera/cds-core';

import { CREDIT_CARD_SAFETY_LINK } from 'bundles/account-settings/constants/SettingsConstants';

import _t from 'i18n!nls/account-settings';

class CreditCardSafetyNotice extends React.Component {
  render() {
    return (
      <div className="rc-CreditCardSafetyNotice caption-text">
        <span className="color-secondary-text">{_t('Your payment information is stored securely.')} </span>
        <Link
          href={CREDIT_CARD_SAFETY_LINK}
          target="_blank"
          rel="noreferrer"
          aria-label={_t('Learn more about saving payment information')}
        >
          {_t('Learn more')}.
        </Link>
      </div>
    );
  }
}

export default CreditCardSafetyNotice;
